import styled from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { TextStyle } from 'components/text';
import { FontSize } from 'commons';

export const Main = styled.div`
  clear: both;
  page-break-inside: avoid;
  page-break-after: always;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  max-width: 10cm;
  height: 100vh;
  max-height: 10cm;
  padding: 10px;

  * {
    font-family: Arial, Helvetica, sans-serif;
  }

  ${TextStyle} {
    font-size: ${FontSize.font14};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  ${HeadingStyle} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
  }

  @media only screen {
    background-color: #fff;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Section = styled.div`
  display: flex;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: flex;
    width: auto;
    max-width: 100px;
    height: 35px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column;
  gap: 6px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: 14px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
